import { render, staticRenderFns } from "./NavView.vue?vue&type=template&id=8dc10eb6&scoped=true&"
import script from "./NavView.vue?vue&type=script&lang=js&"
export * from "./NavView.vue?vue&type=script&lang=js&"
import style0 from "./NavView.vue?vue&type=style&index=0&id=8dc10eb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc10eb6",
  null
  
)

export default component.exports